export default __webpack_public_path__ + "static/media/041-emergency-call.08858c4d.png";